import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "iconOpen", "iconClose"]

  toggle() {
    const isHidden = this.panelTarget.classList.toggle("hidden")
    this.iconOpenTarget.classList.toggle("hidden", !isHidden)
    this.iconCloseTarget.classList.toggle("hidden", isHidden)
  }
}
